// Marca compacta ODPTech (sidebar recolhida): quadrado teal com o "p" branco.
export const LogoIcon = () => (
  <span
    role="img"
    aria-label="odptech"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 28,
      height: 28,
      background: '#17a2b8',
      borderRadius: 6,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 800,
      fontSize: 19,
      lineHeight: 1,
      color: '#ffffff',
      userSelect: 'none',
    }}
  >
    p
  </span>
);
